import {
  getPopular,
  movie,
  series,
  search,
  clearSearch,
  person,
  top,
  history,
  get_plex_media,
  checkConfig,
  discover,
  networkDetails,
  companyDetails,
  guideCalendar,
  discoveryMovies,
  discoveryShows,
  batchLookup,
} from "./actions";

export default {
  getPopular,
  movie,
  series,
  search,
  clearSearch,
  person,
  top,
  history,
  get_plex_media,
  checkConfig,
  discover,
  networkDetails,
  companyDetails,
  guideCalendar,
  discoveryMovies,
  discoveryShows,
  batchLookup,
};
